/**
 * scrollytelling.js
 * Reference-style motion system with Shopify-safe fallbacks.
 * Dependencies: GSAP, ScrollTrigger, Alpine.js
 */

document.addEventListener('alpine:init', () => {
    if (document.querySelector('[data-remie-home]')) {
        return;
    }

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP/ScrollTrigger not loaded. Scrollytelling disabled.');
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    Alpine.data('homeMvScrollAnimation', () => ({
        init() {
            const root = this.$root;
            const gradient = root.querySelector('.mvImageGradient');
            const heroImage = root.querySelector('.mvImage');
            const desktop = window.matchMedia('(min-width: 768px)').matches;
            const blurValue = desktop ? 10 : 20;

            if (!heroImage) {
                return;
            }

            gsap.set(root, { clipPath: 'inset(0 0 0 0)' });
            gsap.set(heroImage, { filter: 'blur(0px)' });

            gsap.timeline({
                scrollTrigger: {
                    trigger: root,
                    start: '0% top',
                    end: '90% top',
                    scrub: 1.4
                }
            })
                .to(gradient, { opacity: 1 }, 0)
                .to(heroImage, { filter: `blur(${blurValue}px)` }, 0);
        }
    }));

    Alpine.data('aboutSectionAnimation', () => ({
        init() {
            const blocks = this.$el.querySelectorAll('[id^="about-content-"]');
            if (!blocks.length) {
                return;
            }

            blocks.forEach((block) => {
                const media = block.querySelector('img, video');
                gsap.set(block, { clipPath: 'inset(0 0 0 0)' });
                gsap.set(media, { yPercent: -6 });

                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: block,
                        start: 'top 85%',
                        end: 'bottom 10%',
                        scrub: 1
                    }
                });

                timeline.to(block, {
                    yPercent: -10,
                    ease: 'linear'
                }, 0);

                if (media) {
                    timeline.to(media, {
                        yPercent: 6,
                        ease: 'linear'
                    }, 0);
                }
            });
        }
    }));

    Alpine.data('doctorsQaAnimation', () => ({
        init() {
            const container = this.$el;
            const header = container.querySelector('.section-header-wrapper');
            const list = container.querySelector('.visual-navigation__list');
            const cards = container.querySelectorAll('.visual-navigation__list-item');

            if (!cards.length) {
                return;
            }

            gsap.set([header, list], { opacity: 0, filter: 'blur(4px)' });
            gsap.set(cards, { opacity: 0, y: 24 });

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: 'top 82%',
                    once: true
                }
            });

            timeline
                .to(header, { opacity: 1, filter: 'blur(0px)', duration: 0.8, ease: 'power1.out' })
                .to(list, { opacity: 1, filter: 'blur(0px)', duration: 0.8, ease: 'power1.out' }, '-=0.5')
                .to(cards, { opacity: 1, y: 0, stagger: 0.12, duration: 0.9, ease: 'power2.out' }, '-=0.4');
        }
    }));

    Alpine.data('userVoiceAnimation', () => ({
        init() {
            const container = this.$el;
            const imagesWrapper = container.querySelector('#voice-images') || container.querySelector('.homepage-content--image');
            if (!imagesWrapper) {
                return;
            }

            const images = Array.from(imagesWrapper.querySelectorAll('img'));
            if (images.length <= 1) {
                return;
            }

            const restImages = images.slice(1);
            gsap.set(restImages, { opacity: 0, scale: 1.05 });

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: '0% 100%',
                    end: '100% 0%',
                    scrub: 1
                }
            });

            timeline
                .fromTo(restImages, { opacity: 0 }, { opacity: 1, duration: 0.65, ease: 'power1.out', stagger: 0.99 }, 0)
                .fromTo(restImages, { scale: 1.05 }, { scale: 1, duration: 1, ease: 'power1.out', stagger: 0.99 }, 0);
        }
    }));

    Alpine.data('largeImageAnimation', () => ({
        init() {
            const container = this.$el;
            const image = container.querySelector('img, .parallax-child');
            if (!image) {
                return;
            }

            const isMobile = window.matchMedia('(max-width: 768px)').matches;
            gsap.fromTo(image, { yPercent: -50 }, {
                yPercent: isMobile ? 0 : 50,
                scrollTrigger: {
                    trigger: container,
                    start: 'top bottom',
                    end: isMobile ? '+=100% bottom' : '+=200% top',
                    scrub: 0
                }
            });
        }
    }));
});
